import { render, staticRenderFns } from "./freeShippingProgressBar.vue?vue&type=template&id=6a2ec3b2"
import script from "./freeShippingProgressBar.vue?vue&type=script&lang=js"
export * from "./freeShippingProgressBar.vue?vue&type=script&lang=js"
import style0 from "./freeShippingProgressBar.vue?vue&type=style&index=0&id=6a2ec3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports